import React from 'react'
import iconsquare from '../../../assets/images/icon-square.png'
import Header from '../../../header'
import axios from 'axios';
import config from '../../../config'
class Graphics extends React.Component{
    constructor(props)
    {
        super(props)
        {
            this.state={
                data:[],
                graphicsloader : false,
                count : 1
            }
        }
        this.graphicsback = this.graphicsback.bind(this)
        this.graphicsnext = this.graphicsnext.bind(this)
    }
    graphicsback()
    {
        this.props.history.push('/dtg-print');
    }
    graphicsnext()
    {
        this.props.history.push('/alphabets');
    }
    componentDidMount()
    {
        this.setState({
            graphicsloader : true
        })
        let apiDynamicUrlAddress = config.default.api1.host;
        let store_id = sessionStorage.getItem('store_id');
        let apiUrl = `${apiDynamicUrlAddress}getAssests?type=graphics&store_id=${store_id}`
        axios.get(apiUrl , {
            crossDomain : true,
            enablePreflight : false
        }).then((response) => {
           if(response.data.success == 1)
            {
                this.setState({
                    graphicsloader : false
                })
                this.setState({data:response.data.data})
            }
        })
        .catch((err) => {

        });
    }
    render()
    {
        const {graphicsloader, count} = this.state;
        let store_name = sessionStorage.getItem('store');
        return(
            <div>
                <Header/>
                <section className="home-register-section">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12 col-lg-12">
                                <div className="home-register-form-div design-menu-sec design-logo-sec">
                                    <div className="form-logo-section sec-center">
                                        <a href={'#/' + store_name}><img src={iconsquare} alt="logo" className="img-fluid brand-logo"/></a>
                                    </div>
                                    <h3>LOOKBOOK</h3>
                                    <h4>Graphics</h4>
                                    {graphicsloader ? 
                                    <div className="spinner-outer">
                                    <div class="spinner-border logo" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    </div>
                                    :
                                    <div>
                                        <div className="col-md-12 sec-center left">
	                                        <div className="design-logo-grid-outer design-graphics-grid-outer">
                                                <div className="design-logo-grid-inner">
                                                {this.state.data && this.state.data.map((item, index)=>{
                                                    return(
	                                                    <div key={index} className="logo-grid-box">
	                                                        <div className="logo-grid-box-img">
	                                                            <img id={item.id} src={item.image_path} alt="logo1" className="img-fluid"/>
	                                                        </div>
	                                                        <div className="logo-grid-box-content">
                                                                <h5>graphic {count + index}</h5>
	                                                        </div>
	                                                </div>
                                                    )
                                                })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    <div className="col-md-12 sec-center left">
                                        <div className="footer-btn"> 
                                            <div className="footer-left-btn"> 
                                                <button onClick={this.graphicsback} className="black_btn">Back</button>
                                            </div>
                                            <div className="footer-right-btn"> 
                                                <button onClick={this.graphicsnext} className="black_btn">Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
export default Graphics;